export  const supportData = [
    { title: "Delete my account", description: "Permanently delete the account and remove access from all workspaces." }
  ];